import React, { useEffect, useState } from 'react';
import { X, Sparkles } from 'lucide-react';
import { PLAN_PRICES_USD, formatUsd } from '../../data/pricingPlans';
export function PromoBanner() {
  const [isVisible, setIsVisible] = useState(true);
  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem('promo-banner-dismissed', 'true');
  };
  useEffect(() => {
    // Check if banner was previously dismissed
    const dismissed = localStorage.getItem('promo-banner-dismissed');
    if (dismissed === 'true') {
      setIsVisible(false);
    }
  }, []);
  if (!isVisible) return null;
  return <div className="relative bg-gradient-to-r from-red-600 via-red-600 to-red-700 text-white shadow-lg z-50" data-id="element-1441" data-mp="3f24rxc0fzlsz">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3" data-id="element-1442" data-mp="3a28yu7ta9es7">
        <div className="flex items-center justify-between gap-4" data-id="element-1443" data-mp="ube36xugljk5">
          {/* Left: Icon + Message */}
          <div className="flex items-center gap-3 flex-1 min-w-0" data-id="element-1444" data-mp="pcb5jygt6fm7">
            <div className="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center" data-id="element-1445" data-mp="pc1dm5c7dydv">
              <Sparkles size={16} className="text-white" data-id="element-1446" data-mp="dlzzbq1e6bv9" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-1447" data-mp="hjnxr32ammrw">
              <p className="text-sm sm:text-base font-semibold leading-tight" data-id="element-1448" data-mp="mklfjeje5esv">
                <span className="hidden sm:inline" data-id="element-1449" data-mp="miirh01stvqs">
                  One full forensic scan for{' '}
                </span>
                <span className="text-yellow-300" data-id="element-1450" data-mp="3q1kesvvel9rx">
                  {formatUsd(PLAN_PRICES_USD.single_scan)}
                </span>
                <span className="hidden sm:inline" data-id="element-1451" data-mp="3v0x21hq6siv1">
                  {' '}
                  — or go unlimited from {formatUsd(PLAN_PRICES_USD.weekly)} a
                  week.
                </span>
                <span className="sm:hidden" data-id="element-1452" data-mp="8lc7511ffozg"> per full scan</span>
              </p>
            </div>
          </div>

          {/* Right: CTA + Close */}
          <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0" data-id="element-1453" data-mp="3c9dyn9s932sh">
            <a href="/payment" className="bg-white text-red-600 px-4 sm:px-6 py-2 rounded-lg font-bold text-sm hover:bg-red-50 transition-all shadow-md hover:shadow-lg whitespace-nowrap" data-id="element-1454" data-mp="3c7ksrwpgomlj">
              Upgrade
            </a>
            <button onClick={handleDismiss} className="p-1.5 hover:bg-white/20 rounded-lg transition-colors flex-shrink-0" aria-label="Dismiss banner" data-id="element-1455" data-mp="3dxg4v3xcgn5e">
              <X size={18} data-id="element-1456" data-mp="2lalux0y5l666" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}
export default PromoBanner;